<template>
  <div class="panel-card">
    <el-button type="primary" @click="onUpgrade" :icon="Position">{{ $str.getKey('设备升级/升级') }}</el-button>
  </div>
  <div class="upgrade-desc">{{ $str.getKey('设备升级/升级历史') }}</div>
  <div class="du-upgrade panel-card">
    <el-form inline>
      <el-form-item :label="$str.getKey('设备升级/状态')">
        <el-select v-model="activeName" @change="onActiveNameChange" filterable>
          <el-option :label="$str.getKey('设备升级/全部')" value=""></el-option>
          <el-option :label="$str.getKey('设备升级/升级成功')" value="upgrade_success"></el-option>
          <el-option :label="$str.getKey('设备升级/升级失败')" value="upgrade_fail"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$str.getKey('设备升级/电站')">
        <el-select v-model="ActiveStation" @change="onActiveStationChange" filterable>
          <el-option :label="$str.getKey('设备升级/全部')" value=""></el-option>
          <el-option :label="s.name" :value="s.stationId" v-for="s in stationList" :key="s.stationId"></el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <div class="upgrade-list">
      <el-table :data="list">
        <el-table-column prop="stationName" :label="$str.getKey('设备升级/电站')">
          <template #default="{ row }">
            <div>{{ $str.getKey('设备升级/电站ID') }}： {{ row.stationId }}</div>
            <div>{{ $str.getKey('设备升级/电站名称') }}： {{ row.stationName }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="fileName" :label="$str.getKey('设备升级/文件名称')" show-overflow-tooltip>
          <template #default="{ row }">
            <span v-if="row.fileName">{{ row.fileName }}</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column prop="upgradeType" :label="$str.getKey('设备升级/升级类型')">
          <template #default="{ row }">
            <el-tag :type="getFileTagType(row.upgradeType)">{{ row.upgradeType }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="equipmentName" label="eLink">
          <template #default="{ row }">
            <div>uuid： {{ row.uuid }}</div>
            <div>{{ $str.getKey('设备升级/名称') }}： {{ row.equipmentName }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" :label="$str.getKey('设备升级/开始升级时间')" />
        <el-table-column prop="upgradeState" :label="$str.getKey('设备升级/状态')">
          <template #default="{ row }">
            <el-tag :type="getUpgradeType(row.upgradeState)">{{ translateUpgradeState(row.upgradeState) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="upgradeState" :label="$str.getKey('设备升级/进度')">
          <template #default="{ row }">
            <div v-if="row.upgradeState === 'upgrade_fail'">--</div>
            <el-progress :percentage="getUpgradePercentage(row.upgradeState).percentage" v-else></el-progress>
          </template>
        </el-table-column>

        <el-table-column prop="formattedUpdateDuration" :label="$str.getKey('设备升级/用时')"></el-table-column>

        <el-table-column :label="$str.getKey('设备升级/操作')">
          <template #default="{ row }">
            <el-button size="small" type="danger" :icon="SwitchButton" @click="shutdown(row)"
              :title="$str.getKey('设备升级/无响应时可手动结束')"
              v-if="row.upgradeState !== 'upgrade_success' && row.upgradeState !== 'upgrade_fail'">{{
                $str.getKey('设备升级/结束') }}</el-button>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column prop="resultMsg" :label="$str.getKey('设备升级/升级结果')">
          <template #default="{ row }">
            <div> {{ row.resultMsg || '--' }}</div>
            <div v-if="row.resultCode == '101'">{{ $str.getKey('设备升级/升级失败设备序号') }}: {{ row.resultFailed }}</div>
          </template>
        </el-table-column>
      </el-table>
      <Pagination v-model="pageNum" :total="total" :page-size="pageSize" @change="restartRefresh" />
    </div>
  </div>

  <el-dialog v-model="isOpen" :title="$str.getKey('设备升级/选择升级包')" width="600px" draggable class="ota-dialog">
    <el-form label-width="100px" :model="upgradeForm" :rules="rules" ref="upgradeFormRef" :disabled="confirmLoading"
      label-position="top">
      <el-form-item :label="$str.getKey('设备升级/选择电站')" prop="station">
        <el-select v-model="station" @change="onStationChange" style="width: 100%;" filterable>
          <el-option :label="s.name" :value="s.stationId" v-for="s in stationList" :key="s.stationId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$str.getKey('设备升级/选择eLink')" prop="eLink">
        <el-select v-model="eLink" style="width: 100%;">
          <el-option :label="$str.getKey('设备升级/全部')" value="all"></el-option>
          <el-option :label="item.equipmentName" :value="item.uuid" v-for="item in eLinkList" :key="item.uuid"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$str.getKey('设备升级/文件')" prop="file">
        <el-select v-model="file" style="width: 100%;" @change="onFileChange">
          <el-option :label="pkg.fileName" :value="pkg.id" v-for="pkg in filterELinkKey(fileList)" :key="pkg.id">
            <div class="opt-row">
              {{ pkg.fileName }}
              <el-tag size="small" style="font-weight: normal">{{ pkg.stationTagName }}</el-tag>
            </div>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$str.getKey('设备升级/私钥文件')" prop="elinkKeyFile" v-if="fileObj.fileType === 'ELINK'">
        <el-select v-model="elinkKeyFile" style="width: 100%;">
          <el-option :label="pkg.fileName" :value="pkg.id" v-for="pkg in elinkKeys" :key="pkg.id">
            <div class="opt-row">
              {{ pkg.fileName }}
              <el-tag size="small" style="font-weight: normal">{{ pkg.stationTagName }}</el-tag>
            </div>
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <template #footer>
      <el-button @click="onCancel()" :disabled="confirmLoading">{{ $str.getKey('设备升级/取消') }}</el-button>
      <el-button type="primary" @click="onConfirm(upgradeFormRef)" :loading="confirmLoading">{{ $str.getKey('设备升级/开始升级')
        }}</el-button>
    </template>
  </el-dialog>
</template>

<script setup>
import { computed, onUnmounted, reactive, ref } from 'vue'
import useAppStore from '@/store/modules/app'
import { getElinkStruct } from '@/api/device/elink'
import { eui } from 'ems-ui'
import { packagesFromStationId, postUpgradeCommand, getUpgradeList, shutdownUpgrade, getFileList } from '@/api/upgrade'
import { useList, translateUpgradeState, getUpgradeType, getUpgradePercentage, getFileTagType, createStorage } from './feature'
import { SwitchButton, Position } from '@element-plus/icons-vue'
import { ElMessageBox } from 'element-plus'
import Pagination from '@/components/Pagination/index.vue'

const $str = window.$str
const { save, load } = createStorage('sessionStorage')
const appStore = useAppStore()
const activeName = ref(load('upgrade-tab', ''))
const ActiveStation = ref(load('upgrade-station', ''))

function onActiveNameChange(value) {
  save('upgrade-tab', value)
  // 用 restartRefresh 而非 fetchList：筛选后可能重新出现进行中的记录，需要重新评估轮询
  restartRefresh()
}

function onActiveStationChange(value) {
  save('upgrade-station', value)
  restartRefresh()
}

function filterELinkKey(list = []) {
  return list.filter(item => item.fileType !== 'ELINK_KEY')
}

// upgrade dialog
function useDialog() {
  const upgradeFormRef = ref(null)
  const isOpen = ref(false)
  const confirmLoading = ref(false)

  const station = ref('')
  const eLink = ref('')
  const file = ref('')
  const fileList = ref([])
  const elinkKeys = ref([])
  const elinkKeyFile = ref()

  const fileObj = computed(() => {
    return fileList.value.find(item => file.value == item.id) || {}
  })

  const keyFileObj = computed(() => {
    return elinkKeys.value.find(item => elinkKeyFile.value == item.id)
  })

  const stationList = computed(() => {
    return appStore.stations
  })

  const eLinkList = ref([])

  const onStationChange = (sid) => {
    eLink.value = ''
    file.value = ''

    getElinkStruct(sid).then(res => {
      eLinkList.value = res.data
    })

    packagesFromStationId(sid).then(res => {
      fileList.value = res.data
    })
  }

  const onFileChange = () => {
    // 文件类型是eLink时 请求秘钥文件列表
    if (fileObj.value.fileType === 'ELINK') {
      getFileList(null, null, 1, 65535, 'ELINK_KEY').then(r => {
        const stationTag = fileObj.value.stationTag
        elinkKeys.value = r.rows.filter(item => item.stationTag == stationTag)
      })
    }
    elinkKeyFile.value = ''
  }

  const onUpgrade = () => {
    isOpen.value = true
    station.value = ''
    eLink.value = ''
    file.value = ''
  }

  const onCancel = () => {
    isOpen.value = false
  }

  const uuids = computed(() => {
    const arr = [eLink.value]
    if (eLink.value === 'all') {
      return eLinkList.value.map(item => item.uuid)
    }
    return arr
  })

  const onConfirm = (cpmt) => {
    cpmt.validate((valid) => {
      if (valid) {
        confirmLoading.value = true
        postUpgradeCommand(station.value, uuids.value, fileObj.value, keyFileObj.value)
          .then(() => {
            eui.showTopTip($str.getKey('设备升级/升级命令已下发'))
            isOpen.value = false
            // 新下发的记录处于进行中，需重新拉起轮询
            restartRefresh()
          })
          .catch(err => {
            console.warn(err)
          })
          .finally(() => {
            confirmLoading.value = false
          })
      }
    })
  }

  const upgradeForm = reactive({
    station,
    eLink,
    file,
    elinkKeyFile,
  })

  const rules = reactive({
    station: [
      { required: true, message: $str.getKey('设备升级/请选择电站'), trigger: 'blur' },
    ],
    eLink: [
      { required: true, message: $str.getKey('设备升级/请选择eLink'), trigger: 'blur' },
    ],
    file: [
      { required: true, message: $str.getKey('设备升级/请选择文件'), trigger: 'blur' },
    ],
    elinkKeyFile: [
      { required: true, message: $str.getKey('设备升级/请选择私钥文件'), trigger: 'blur' },
    ],
  })

  return {
    isOpen,
    onUpgrade,
    station,
    eLink,
    file,
    onCancel,
    onConfirm,
    confirmLoading,
    stationList,
    eLinkList,
    fileList,
    elinkKeys,
    elinkKeyFile,
    fileObj,
    onFileChange,
    upgradeFormRef,
    upgradeForm,
    rules,
    onStationChange,
  }
}

const {
  upgradeFormRef,
  isOpen,
  onUpgrade,
  station,
  eLink,
  file,
  onCancel,
  onConfirm,
  confirmLoading,
  stationList,
  eLinkList,
  fileList,
  elinkKeys,
  elinkKeyFile,
  fileObj,
  onFileChange,
  upgradeForm,
  rules,
  onStationChange
} = useDialog()

function convertMillisecondsToTime(milliseconds) {
  var seconds = Math.floor((milliseconds / 1000) % 60)
  var minutes = Math.floor((milliseconds / (1000 * 60)) % 60)
  var hours = Math.floor((milliseconds / (1000 * 60 * 60)) % 24)

  hours = (hours < 10) ? "0" + hours : hours
  minutes = (minutes < 10) ? "0" + minutes : minutes
  seconds = (seconds < 10) ? "0" + seconds : seconds

  return hours + ":" + minutes + ":" + seconds
}

const { list, pageNum, pageSize, total, fetchList } = useList(({ pageNum, pageSize }) => {
  return getUpgradeList(ActiveStation.value, activeName.value, pageNum, pageSize)
}, false, (ls) => formatDuration(ls))

function formatDuration(dtList) {
  dtList.forEach(dt => {
    const isUpgrading = dt.upgradeState !== "upgrade_success" && dt.upgradeState !== "upgrade_fail"
    let updateDuration = isUpgrading ? (new Date() - new Date(dt.createTime)) : (new Date(dt.updateTime) - new Date(dt.createTime))
    updateDuration = Math.max(0, updateDuration)
    dt.updateDuration = updateDuration
    dt.formattedUpdateDuration = convertMillisecondsToTime(updateDuration)
  })
}

function shutdown(record) {
  ElMessageBox.prompt($str.getKey('设备升级/请输入结束原因'), $str.getKey('设备升级/提示'), {
    confirmButtonText: $str.getKey('设备升级/确定'),
    cancelButtonText: $str.getKey('设备升级/取消'),
    inputPlaceholder: $str.getKey('设备升级/选填')
  })
    .then(async ({ value }) => {
      await shutdownUpgrade(record.id, value)
      restartRefresh()
    })
    .catch(() => { })
}

// 升级进度靠轮询获取。仅在列表中存在「进行中」的记录时才继续轮询，
// 全部终态(成功/失败)时停止，避免页面停留期间无意义地每 2 秒打一次接口。
const UPGRADE_DONE_STATES = ['upgrade_success', 'upgrade_fail']
const hasUpgradingRecord = () =>
  list.value.some(row => !UPGRADE_DONE_STATES.includes(row.upgradeState))

let t
let stopped = false

function scheduleNext() {
  clearTimeout(t)
  if (stopped || !hasUpgradingRecord()) return
  t = setTimeout(startRefresh, 2000)
}

function startRefresh() {
  Promise.resolve(fetchList()).finally(() => scheduleNext())
}

// 首次进入、切换筛选/分页后都要重新评估：此时可能又出现了进行中的记录
function restartRefresh() {
  clearTimeout(t)
  startRefresh()
}

startRefresh()

onUnmounted(() => {
  stopped = true
  clearTimeout(t)
})
</script>

<style lang='scss' src="./style.scss"></style>

<style lang='scss' scoped>
.upgrade-list {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.upgrade-desc {
  margin-left: 16px;
  margin-top: 16px;
  color: var(--color-black-45, rgba(0, 0, 0, 0.45));
}

.opt-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
